import axios from "axios";

export const baseUrl=`https://mate.rashigames.com/`;
// export const baseUrl=`/`;

export const getGamesApi=async()=>{
    const response=await axios.get(`${baseUrl}api/v1/games`);
    return response;
}

const gamesApi=`${baseUrl}api/content`;
export {gamesApi};

const loginApi=`${baseUrl}api/login`;
export {loginApi};

const subscribeApi=`${baseUrl}subscribe-user`;
export {subscribeApi};

const deactivateApi=`${baseUrl}deactivate-user`;
export {deactivateApi};